import { render, staticRenderFns } from "./productInfo.vue?vue&type=template&id=ae94ba4c&scoped=true"
import script from "./productInfo.vue?vue&type=script&lang=js"
export * from "./productInfo.vue?vue&type=script&lang=js"
import style0 from "./productInfo.vue?vue&type=style&index=0&id=ae94ba4c&prod&scoped=true&lang=less"
import style1 from "./productInfo.vue?vue&type=style&index=1&id=ae94ba4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae94ba4c",
  null
  
)

export default component.exports